module.exports = __webpack_public_path__ + "static/media/test.643dc9e4.mp3";